module.exports = __webpack_public_path__ + "static/media/logo-hor.608e7efb.svg";